export const formatLocalAccount = (account: {
  prefix?: string | null;
  accountNumber: string;
  bankCode: string;
}) =>
  account.prefix
    ? `${account.prefix}-${account.accountNumber}/${account.bankCode}`
    : `${account.accountNumber}/${account.bankCode}`;
